module.exports = __webpack_public_path__ + "static/media/Source Info.0a285037.txt";